import { render, staticRenderFns } from "./FormItemJumpAction.vue?vue&type=template&id=33200aaa"
import script from "./FormItemJumpAction.vue?vue&type=script&lang=js"
export * from "./FormItemJumpAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports